import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
// Critical CSS - load immediately
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
import store from "./core/data/redux/store";
import { Provider } from "react-redux";
// Defer non-critical icon CSS loading
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../src/style/icon/fontawesome/css/fontawesome.min.css";
import "../src/style/icon/fontawesome/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import ALLRoutes from "./feature-module/router/router";
import { ConfigProvider } from "antd";
import { SnackbarProvider } from "notistack";
import * as Sentry from "@sentry/react";

// Defer Bootstrap JS loading - load after initial render
if (typeof window !== 'undefined') {
  // Use requestIdleCallback for better performance, fallback to setTimeout
  const loadBootstrap = () => {
    // Dynamic import with type assertion to avoid TypeScript error
    // @ts-ignore - Bootstrap JS file doesn't have type definitions
    import("../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js").catch(() => {
      // Silently fail if bootstrap JS fails to load
    });
  };

  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(loadBootstrap, { timeout: 2000 });
  } else {
    setTimeout(loadBootstrap, 1);
  }
}

Sentry.init({
  dsn: "https://9eb68f449b9086e1fb5888ee34c9b226@o4509138929778688.ingest.us.sentry.io/4509138931875840",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

// Service worker: network-first HTML (see public/service-worker.js). Reload when a new version activates.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  let refreshing = false;
  let firstControllerChange = true;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (firstControllerChange) {
      firstControllerChange = false;
      return;
    }
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        registration.addEventListener('updatefound', () => {
          const w = registration.installing;
          if (!w) return;
          w.addEventListener('statechange', () => {
            if (w.state === 'installed' && navigator.serviceWorker.controller) {
              w.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
        registration.update().catch(() => {});
        setInterval(() => registration.update().catch(() => {}), 60 * 60 * 1000);
      })
      .catch(() => {});
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            // Seed Token
            colorPrimary: '#506EE4',
          },
          components: {
            // Component Token
            Button: {
              colorPrimaryHover: '#3154df',
              borderRadius: 5,
              fontSize: 14,
              fontWeight: 500,
            },
          }
        }}
      >
        <SnackbarProvider>

          <BrowserRouter basename={base_path}>
            <ALLRoutes />
          </BrowserRouter>
        </SnackbarProvider>
        
      </ConfigProvider>
    </Provider>
  </React.StrictMode>
);
